import { type ProfileResource, resolveId } from '@medplum/core'
import type { ClientApplication, Reference } from '@medplum/fhirtypes'
import { isAvatarResource } from '@seen/core/models/profile'
import { getType } from '@seen/core/utils'
import { useFhirReadHistory } from '#src/hooks/useFhirReadHistory.ts'
import { useWarningReporter } from '#src/hooks/useWarningReporter.ts'

interface UseCreatedByResult {
  data: Reference<ProfileResource> | Reference<ClientApplication> | undefined
  isLoading: boolean
}

export function useCreatedBy(reference: Reference): UseCreatedByResult {
  const { data: history, isLoading } = useFhirReadHistory(
    getType(reference),
    resolveId(reference)
  )
  const oldestVersionResource = history?.entry?.at(-1)?.resource
  const createdBy = oldestVersionResource?.meta?.author

  useWarningReporter(
    !!createdBy &&
      !isAvatarResource(createdBy) &&
      `${reference.reference} unexpected author type ${getType(createdBy)}`
  )

  if (!createdBy) {
    return { data: undefined, isLoading }
  }
  if (!isAvatarResource(createdBy)) {
    return { data: undefined, isLoading }
  }
  return { data: createdBy, isLoading }
}
